import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl, defineMessages } from "react-intl";
import * as validFunc from "libs/validation";

import { Icon, Image, Message, Popup } from "semantic-ui-react";

import {
  ReduxFormSemanticDropdown,
  ReduxFormSemanticCheckBox,
  ReduxFormHiddenRecord,
  ReduxFormSlider,
  StartExamLicenseMessage,
} from "components";

import * as common from "libs/commonFunc";

import classNames from "classnames/bind";
import styles from "./StartExam.css";
const cx = classNames.bind(styles);

class StartExamWizardContentStep3 extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    // state
    const {
      loadingTargetTag,
      targetSelectCount,
      licenseResult,
      examPrepareData,
      invalid,
    } = this.props;
    const {
      loading,
      formStore,
      fieldInfo,
      tagData,
      initTargetTags,
    } = this.props;

    const { isAllTarget, examTargetTag, exceptExamTargetTag, syncErrors, examTargetRandomPer } =
      formStore && formStore.values;

    // 태그 호출 새로고침
    // const targetTagRefresh = () => {
    //   if (!this.state.loadingTargetTag) {
    //     this.setState({ loadingTargetTag: true });
    //   }
    //   initTargetTags();
    //   this.setState({ loadingTargetTag: false });
    // };

    let tagDataByName = {};
    let tagTargetCount = 0;
    if (tagData && typeof tagData === "object") {
      for (const no in tagData) {
        if (tagData.hasOwnProperty(no)) {
          tagTargetCount += tagData[no].targetCount || 0;

          tagDataByName[tagData[no].tagName] = {
            key: no,
            value: no,
            label: {
              className: "tag-" + tagData[no].color,
              empty: true,
              circular: true,
            },
            data: {
              color: "tag-label-" + tagData[no].color,
            },
            text:
              tagData[no].tagName +
              " - " +
              tagData[no].targetCount +
              defineMessages(
                formatMessage({
                  id: "StartExamWizardContent_13",
                  defaultMessage: "명",
                })
              ),
            content: (
              <div className="item-info">
                <div className="list-name">{tagData[no].tagName}</div>
                <div className="list-target-count">
                  {tagData[no].targetCount +
                    " " +
                    defineMessages(
                      formatMessage({
                        id: "StartExamWizardContent_13",
                        defaultMessage: "명",
                      })
                    )}
                </div>
              </div>
            ),
            className: "list-item",
            disabled: tagData[no].targetCount ? false : true,
          };
        }
      }
    }

    // 정렬 처리 - 대상자가 있는 태그순, ㄱㄴㄷ순
    tagDataByName = common.sortObjectByKey(tagDataByName);

    const enabledtagOptions = [];
    const disabledTagOptions = [];
    for (const name in tagDataByName) {
      if (tagDataByName.hasOwnProperty(name)) {
        // 대상자가 있는 태그 먼저 표시
        if (!tagDataByName[name].disabled) {
          disabledTagOptions.push(tagDataByName[name]);
        } else {
          enabledtagOptions.push(tagDataByName[name]);
        }
      }
    }

    const tagOptions = disabledTagOptions.concat(enabledtagOptions);

    let renderTagList = null;
    let exceptRenderTagList = null;
    if (!loading) {
      let inTag = [...tagOptions];
      if(!!exceptExamTargetTag){
        inTag = tagOptions.filter(tag => exceptExamTargetTag.indexOf(tag.key) < 0);
      }

      if (Array.isArray(inTag) && inTag.length > 0) {
        // let tagTargetPlacholder =
        //   fieldInfo.examTargetTag.label +
        //   ' ' +
        //   defineMessages(formatMessage({ id: 'StartExamWizardContent_15', defaultMessage: '선택' }));
        let tagTargetPlacholder = validFunc.examTargetRequried();
        if (tagTargetCount === 0) {
          tagTargetPlacholder = defineMessages(
            formatMessage({
              id: "StartExamWizardContent_14",
              defaultMessage: "태그에 할당된 대상자가 없습니다",
            })
          );
        }

        renderTagList = (
          <ReduxFormSemanticDropdown
            placeholder={tagTargetPlacholder}
            name="examTargetTag"
            className={cx("list-target")}
            fluid
            multiple
            search
            selection
            selectOnBlur={false}
            disabled={isAllTarget ? true : false}
            options={inTag}
            loading={loadingTargetTag}
            defaultValue={
              examTargetTag && Array.isArray(examTargetTag) ? examTargetTag : []
            }
            error={
              fieldInfo.examTargetSelected.error ||
              tagTargetCount === 0 ||
              (examTargetTag && examTargetTag.length < 1 && !isAllTarget)
            }
            errorMessage={syncErrors && syncErrors.examTargetSelected}
            checkType={101}
            renderLabel={(label, index) => ({
              className: label.data.color,
              content: label.text,
            })}
          />
        );
      } else {
        renderTagList = (
          <Message warning size="small">
            <Message.Header>
              <Icon name="exclamation circle" />
              {defineMessages(
                formatMessage({
                  id: "StartExamWizardContent_16",
                  defaultMessage: "대상자 태그가 없습니다.",
                })
              )}
            </Message.Header>
            <p>
              {defineMessages(
                formatMessage({
                  id: "StartExamWizardContent_17",
                  defaultMessage:
                    "대상자를 추가하고 태그를 부여하면 태그를 이용하여 여러 대상자를 한번에 선택할 수 있습니다.",
                })
              )}
            </p>
          </Message>
        );
      }

      let exceptTag = [...tagOptions];
      if(!!examTargetTag){
        exceptTag = tagOptions.filter(tag => examTargetTag.indexOf(tag.key) < 0);
      }

      if (Array.isArray(exceptTag) && exceptTag.length > 0) {
        // let tagTargetPlacholder =
        //   fieldInfo.examTargetTag.label +
        //   ' ' +
        //   defineMessages(formatMessage({ id: 'StartExamWizardContent_15', defaultMessage: '선택' }));
        let tagTargetPlacholder = validFunc.examTargetRequried();

        exceptRenderTagList = (
          <ReduxFormSemanticDropdown
            placeholder={tagTargetPlacholder}
            name="exceptExamTargetTag"
            className={cx("list-target")}
            fluid
            multiple
            search
            selection
            selectOnBlur={false}
            options={exceptTag}
            loading={loadingTargetTag}
            defaultValue={
              exceptExamTargetTag && Array.isArray(exceptExamTargetTag) ? exceptExamTargetTag : []
            }
            error={false}
            errorMessage={syncErrors && syncErrors.examTargetSelected}
            checkType={101}
            renderLabel={(label, index) => ({
              className: label.data.color,
              content: label.text,
            })}
          />
        );
      } else {
        exceptRenderTagList = (
          <Message warning size="small">
            <Message.Header>
              <Icon name="exclamation circle" />
              {defineMessages(
                formatMessage({
                  id: "StartExamWizardContent_16",
                  defaultMessage: "대상자 태그가 없습니다.",
                })
              )}
            </Message.Header>
            <p>
              {defineMessages(
                formatMessage({
                  id: "StartExamWizardContent_17",
                  defaultMessage:
                    "대상자를 추가하고 태그를 부여하면 태그를 이용하여 여러 대상자를 한번에 선택할 수 있습니다.",
                })
              )}
            </p>
          </Message>
        );
      }
    }

    return (
      <div className={cx("target-conf-area")}>
        <ReduxFormHiddenRecord
          name="examTargetSelected"
          validate={["examTargetRequried"]}
          valuePass={
            examPrepareData.targetCount > 0 &&
            (isAllTarget === 1 || (examTargetTag && examTargetTag.length > 0))
          }
        />
        {/* targetSelectCount || */}
        <div className={cx("select-target-area")}>
          <div className={cx("list-label")}>
            {defineMessages(
              formatMessage({
                id: "StartExamWizardContent_18",
                defaultMessage: "대상자 태그 선택",
              })
            )}
          </div>
          <div className={cx("list-list")}>
            <div
              className={cx(
                "list-dropdown",
                "drop-area",
                examPrepareData.targetCount < 1 ? "disabled" : ""
              )}
            >
              {renderTagList}
            </div>
            {/* <Tooltip
            title={defineMessages(
              formatMessage({ id: 'StartExamWizardContent_93', defaultMessage: '선택한 태그 전체 삭제' })
            )}
            placement="bottom">
            <div className={cx('list-refresh')} onClick={targetTagRefresh}>
              <Icon link name="refresh" />
            </div>
          </Tooltip> */}
          </div>
          {/* 모든 대상자 선택 */}
          <div className={cx("list-list")}>
            <ReduxFormSemanticCheckBox
              name="isAllTarget"
              className={cx(
                "checkbox-isAllTarget",
                examPrepareData.targetCount < 1 ? "disabled" : ""
              )}
              label={fieldInfo.isAllTarget.label}
            />
          </div>
          <div className={cx("list-label")}>
            {defineMessages(
              formatMessage({
                id: "StartExamWizardContent_125",
                defaultMessage: "예외 태그 선택",
              })
            )}
          </div>
          <div className={cx("list-list")}>
            <div
              className={cx(
                "list-dropdown",
                "drop-area",
                examPrepareData.targetCount < 1 ? "disabled" : ""
              )}
            >
              {exceptRenderTagList}
            </div>
          </div>
        </div>
        <div className={cx("select-targetPer-area")}>
          <div className={cx("targetPer-title")}>
            {defineMessages(
              formatMessage({
                id: "StartExam_11",
                defaultMessage: "훈련 대상자 선택 비율",
              })
            )}
            <Popup
              className="max-250"
              position="right center"
              trigger={
                <Image
                  className={cx("ml-5")}
                  src="/img/examStart/btn_qmark.png"
                />
              }
              content={defineMessages(
                formatMessage({
                  id: "StartExamWizardContent_78",
                  defaultMessage:
                    "선택한 대상자의 발송 비율입니다. (예> 100명의 대상자, 발송 비율 70% -> 70명 훈련 실시)",
                })
              )}
            />
          </div>
          <div className={cx("targetPer-content")}>
            <div className={cx("list-list")}>
              <div
                className={cx("exam-target-slider-10", {
                  "rc-slider-disabled": invalid,
                })}
              >
                <div className={cx("inner")} />
              </div>
              <div className={cx("exam-target-slider")}>
                <ReduxFormSlider
                  name="examTargetRandomPer"
                  defaultValue={examTargetRandomPer ? examTargetRandomPer : 100}
                  value={examTargetRandomPer ? examTargetRandomPer : 100}
                  // dots
                  step={5}
                  disabled={invalid}
                />
              </div>
              <div className={cx("exam-target-value")}>
                {examTargetRandomPer ? examTargetRandomPer + "%" : "100%"}
              </div>
            </div>
          </div>
        </div>
        {!!licenseResult && !licenseResult.isValidLicense ? (
          <StartExamLicenseMessage licenseResult={licenseResult} step={3} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  templateAttach: state.templateAttach.getIn(["data", "success"]),
  templateAttachIndex: state.templateAttach.get("listIndexByNo"),
});

export default connect(mapStateToProps)(
  injectIntl(StartExamWizardContentStep3)
);



// WEBPACK FOOTER //
// ./src/script/components/exam-start/StartExamWizardContentStep3.js